import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { SendMarketingEmailInput } from '@/models/marketing';

export const sendMarketingEmail = async ({ type, phoneNumber, email, language }: SendMarketingEmailInput) => {
  const response = await mutationExecute({
    variables: {
      type,
      phoneNumber,
      email,
      language,
    },
    mutation: graphql(`
      mutation SendMarketingEmail($type: String!, $phoneNumber: String, $email: String, $language: String) {
        sendMarketingEmail(type: $type, phoneNumber: $phoneNumber, email: $email, language: $language)
      }
    `),
  });

  return response.data?.sendMarketingEmail ?? false;
};
